// Generated by OrchestKit Claude Plugin
// Created: 2026-09-24

import type { LignePanier } from './calculs.ts';

/** Produit vendable — réponse de `GET /produits` (camelCase, voir depot-catalogue.ts). */
export interface ProduitVendable {
  id: string;
  reference: string;
  designation: string;
  quantiteMinimale: number;
  prixUnitaire: number;
  stockDisponible: number;
}

/**
 * Ligne de panier + seuil du canal au moment de l'ajout (avertissement
 * RG-035) + prix catalogue au moment de l'ajout : `prixUnitaire` reste
 * modifiable par le vendeur, `prixCatalogue` ne bouge jamais — les deux sont
 * envoyés au serveur, qui les conserve tous les deux (migration 023).
 */
/** Un IMEI + un second IMEI facultatif (double SIM, même appareil) par unité. */
export interface PaireImei {
  imei: string;
  imei2: string;
}

export interface LignePanierVente extends LignePanier {
  quantiteMinimale: number;
  prixCatalogue: number;
  /** Une paire IMEI/IMEI2 par unité vendue, facultative — migrations 024/026 côté API. */
  imeis: PaireImei[];
}

export interface Reglement {
  mode: string;
  montant: number;
}

export const MODES = ['ESPECES', 'MOBILE_MONEY', 'VIREMENT', 'CHEQUE', 'AVOIR'] as const;
